export const autoCharge = {
    "ownerId": "ID del propietario de la cuenta",
    "continue": "Continuar con la firma digital",
    "apartment": "Apartamento",
    "confirm": "Confirmar",
    "signature": "Firma",
    "clear": "Borrar",
    "fileName": "Bank_charge_agreement_for_",
    "success": "¡Se envió la solicitud!",
    "back": "Atrás",
    "date": "Fecha de facturación",
    "title": "Complete los detalles para establecer una orden permanente de débito directamente de la cuenta bancaria",
    "address": "Dirección",
    "name": "Nombre",
    "phone": "Teléfono"
};
